var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1449 8.23567C11.6011 8.77798 10.887 9.11621 10.1229 9.19332C9.3588 9.27043 8.59149 9.08172 7.95033 8.65899L6.95944 9.64988L7.90225 10.5927L6.95944 11.5355L6.01663 10.5927L5.07382 11.5355L6.48803 12.9497L5.54522 13.8925L4.13101 12.4783L3.65961 12.9497L2.7168 12.0069L7.00752 7.71618C6.58479 7.07502 6.39607 6.30771 6.47319 5.54361C6.5503 4.77952 6.88853 4.06539 7.43084 3.52162C8.7305 2.22196 10.8452 2.22196 12.1449 3.52162C13.4445 4.82128 13.4445 6.936 12.1449 8.23567ZM8.37365 4.46443C7.59395 5.24413 7.59395 6.51315 8.37365 7.29286C9.15335 8.07256 10.4224 8.07256 11.2021 7.29286C11.9818 6.51315 11.9818 5.24413 11.2021 4.46443C10.4224 3.68473 9.15335 3.68473 8.37365 4.46443Z",
    fill: "#8A9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.5d071d7dd5baa94961b2a1f6b1cfafc5.svg";
export { ForwardRef as ReactComponent };